import { useTranslation } from 'react-i18next'
import { Globe } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { client } from '@/api/client'
import { useAuthStore } from '@/stores/auth'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const { isAuthenticated, updateParent } = useAuthStore()

  const toggleLanguage = async () => {
    const newLng = i18n.language === 'el' ? 'en' : 'el'
    i18n.changeLanguage(newLng)

    if (isAuthenticated) {
      try {
        const response = await client.patch('/profile/', {
          language_preference: newLng
        })
        updateParent(response.data)
      } catch (error) {
        console.error('Failed to update language preference:', error)
      }
    }
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLanguage}
      className="gap-1.5"
      aria-label={`Switch to ${i18n.language === 'el' ? 'English' : 'Greek'}`}
    >
      <Globe className="h-4 w-4" />
      {i18n.language === 'el' ? 'EN' : 'GR'}
    </Button>
  )
}
